import { type Dtos, type IncomeStatementId, type SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { incomeStatementsQueryKey } from "../../financials";

export function useAdminMarkIncomeStatementUnreviewed(accountId: SuretyAccountId) {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: (incomeStatementId: IncomeStatementId) =>
			post<Dtos.Admin.IncomeStatement.Get.Response>(
				`/v2/admin/surety/accounts/${accountId}/income-statements/${incomeStatementId}/unreview`,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: incomeStatementsQueryKey(accountId) });
		},
	});

	return {
		unreviewIncomeStatement: mutation.mutate,
		unreviewISLoading: mutation.isPending,
		unreviewISError: mutation.error,
		resetUnreviewISError: mutation.reset,
	};
}
